import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact from '../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Label from '../../../../../incase-domain/components/label/Label';
import {IElementSequenceQuestion, SequenceQuestionMode} from '../../../../../incase-domain/elements/question/questionSequence';

interface SequenceModeSelectProps {
    highlightedElement: IElementSequenceQuestion;
    highlightedElementChangeHandler: {
        single: (field: keyof IElementSequenceQuestion | string, value: unknown) => void;
    };
}

export default function SequenceModeSelect(props: SequenceModeSelectProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler} = props;
    const {t} = useTranslation();

    const options = [
        {label: t('presEditPage.editSidebar.elements.sequenceQuestion.modeDrag'), value: SequenceQuestionMode.DRAG},
        {label: t('presEditPage.editSidebar.elements.sequenceQuestion.modeClick'), value: SequenceQuestionMode.CLICK},
    ];
    const selectedMode = highlightedElement.sequenceMode || SequenceQuestionMode.DRAG;

    return (
        <div className="l-group--form">
            <div className="l-group__item">
                <Label>{t('presEditPage.editSidebar.elements.sequenceQuestion.mode')}</Label>
                <DropdownMenuCompact
                    width="full"
                    className="c-sidepanel__dropdown"
                    items={[
                        options.map((option) => ({
                            label: option.label,
                            onClick: () => highlightedElementChangeHandler.single('sequenceMode', option.value),
                        })),
                    ]}
                >
                    <Button
                        variant="soft"
                        size="xs"
                        fullWidth
                        trailing="solar:alt-arrow-down-linear"
                        className="c-sidepanel__dropdown_button"
                    >
                        {options.find((option) => option.value === selectedMode)?.label}
                    </Button>
                </DropdownMenuCompact>
            </div>
        </div>
    );
}
